import React from 'react'

export default function Header() {
    return (
        <div className="header">
            <h1>TOP 10 MOVIE LIST</h1>
        </div>
    )
}

